const UiFormPropsOption = {
  data: {
    type: Object,
    default: () => {
    }
  },
  rules: {
    type: Object,
    default: () => {
    }
  }
};

export { UiFormPropsOption };
//# sourceMappingURL=index.mjs.map
